import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page2[0]",
	date: 'topmostSubform[0].Page2[0].DATE_SIGNATURE[0]',
	lawFirmAddress: 'topmostSubform[0].Page2[0].NOTAIRE_ADRESSE[0]',
	faxNumber: 'topmostSubform[0].Page2[0].Solicitor_Fax_Number[0]',
	telephoneNumber: 'topmostSubform[0].Page2[0].SolicitorPhoneNumber[0]',
	lawFirmName: 'topmostSubform[0].Page2[0].NOTARY_FIRM_NAME[0]',
	address: 'topmostSubform[0].Page2[0].ADDRESS_SERVICE_CENTER[0]',
	branchTransit: 'topmostSubform[0].Page2[0].TRANSIT_SERVICE_CENTER[0]',
	dateFundsRequired: 'topmostSubform[0].Page2[0].DATE_FUNDS_REQUIRED[0]',
	transitNumber: 'topmostSubform[0].Page2[0].TRANSIT_NUMBER[0]',
	amountRequiredToBeFunded: 'topmostSubform[0].Page2[0].AMOUNT_REQUESTED[0]',
	bankName: 'topmostSubform[0].Page2[0].BANK_NAME_TRUST_ACCOUNT[0]',
	exceptions: 'topmostSubform[0].Page2[0].EXCEPTION_DETAILS[0]',
	province2: 'topmostSubform[0].Page2[0].ADR_PROP1_CODE_PROVINCE[0]',
	trustNumber: 'topmostSubform[0].Page2[0].TRUST_ACCOUNT_NUMBER[0]',
	// "16":"topmostSubform[0].Page1[0]",
	province: 'topmostSubform[0].Page1[0].ADR_PROP1_CODE_PROVINCE[0]',
	selectedOption: 'topmostSubform[0].Page1[0].CHK_SELECT_OPTION[0]',
	titleInsuranceCertificateNumber:
		'topmostSubform[0].Page1[0].TITLE_ASSURANCE_CERTIFICAT_NUMBER[0]',
	titleInsuranceCompanyName:
		'topmostSubform[0].Page1[0].TITLE_ASSURANCE_NAME[0]',
	mortgageRank: 'topmostSubform[0].Page1[0].MORTGAGE_RANK[0]',
	HPPAmountToBeRegistered: 'topmostSubform[0].Page1[0].AMONT_REGISTERED[0]',
	annualTaxAmount: 'topmostSubform[0].Page1[0].ANNUAL_TAX_AMOUNT[0]',
	municipalTaxOfficeName:
		'topmostSubform[0].Page1[0].NAME_MUNICIPAL_TAX_OFFICE[0]',
	legalDescription: 'topmostSubform[0].Page1[0].LEGAL_DESCRIPTION[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].ADR_PROP1_RUE[0]',
	mortgagor: 'topmostSubform[0].Page1[0].ALL_BWR_OR_COMPANYNAME_LINE2[0]',
	borrowers: 'topmostSubform[0].Page1[0].ALL_BWR_OR_COMPANYNAME[0]',
	cibcPlcReferenceNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	re: 'topmostSubform[0].Page1[0].OBJECT[0]',
	// "31":"topmostSubform[0].Page1[0].BARCODE_FAX_RETURN_LENDER[0]",
	rollNumber: 'topmostSubform[0].Page1[0].ROLE_NUMBER[0]',
};

export interface CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS {
	re: string;
	cibcPlcReferenceNumber: string;
	borrowers: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	municipalTaxOfficeName: string;
	rollNumber: string;
	annualTaxAmount: string;

	HPPAmountToBeRegistered: string;
	mortgageRank: string;

	selectedOption: string;

	titleInsuranceCompanyName: string;
	titleInsuranceCertificateNumber: string;

	province: string;
	province2: string;

	exceptions: string;

	bankName: string;
	amountRequiredToBeFunded: string;
	transitNumber: string;
	trustNumber: string;
	dateFundsRequired: string;

	branchTransit: string;
	address: string;
	lawFirmName: string;
	telephoneNumber: string;
	faxNumber: string;
	lawFirmAddress: string;

	date: string;
}
